import StudentCompetencySubmittedSurveyListActionTypes from '../actions/student-competency-submitted-survey-list-action-types';

const initialState = {
  loading: false,
  studentCompetencySubmittedSurveys: null,
  studentCompetencySubmittedSurveysCancelToken: null,
  sorting: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case StudentCompetencySubmittedSurveyListActionTypes.LOAD_STUDENT_COMPETENCY_SUBMITTED_SURVEY_LIST_START:
      return {
        ...state,
        loading: true
      };
    case StudentCompetencySubmittedSurveyListActionTypes.LOAD_STUDENT_COMPETENCY_SUBMITTED_SURVEY_LIST_END:
      return {
        ...state,
        studentCompetencySubmittedSurveys: action.payload,
        loading: false
      };
    case StudentCompetencySubmittedSurveyListActionTypes.CLEAR_STUDENT_COMPETENCY_SUBMITTED_SURVEY_LIST:
      return initialState;
    case StudentCompetencySubmittedSurveyListActionTypes.SORT_STUDENT_COMPETENCY_SUBMITTED_SURVEY_LIST:
      return {
        ...state,
        sorting: action.payload
      };
    default:
      return state;
  }
};
